import { ReactNode } from 'react';
import { MetaData } from 'components/atoms/PageMetaData/PageMetaData';
import Heading from 'components/atoms/Heading/Heading';
import Txt from 'components/atoms/Txt/Txt';

interface LandingPageConfig {
  metaData: MetaData;
  leftColumnContent: ReactNode;
}

const defaultDescription =
  'Qmee cash rewards, discounts & surveys. Search, earn and save today and put cash back in your wallet.';

const LANDING_PAGES: Record<string, LandingPageConfig> = {
  'cash-app': {
    metaData: {
      title: "Qmee - Take paid surveys with Qmee's cash app.",
      description: defaultDescription,
    },
    leftColumnContent: (
      <>
        <Heading level={1}>
          Take paid surveys with <Txt component="strong">Qmee&apos;s cash app</Txt>
        </Heading>
        <Txt component="p">
          Forget swag or points - withdraw your <Txt component="strong">cash instantly</Txt> with
          Qmee.
        </Txt>
      </>
    ),
  },
  'earn-money': {
    metaData: {
      title: "Qmee - Earn money with Qmee's paid surveys.",
      description: defaultDescription,
    },
    leftColumnContent: (
      <>
        <Heading level={1}>
          Earn money with Qmee&apos;s <Txt component="strong">paid surveys</Txt>
        </Heading>
        <Txt component="p">
          Forget swag or points - withdraw your <Txt component="strong">cash instantly</Txt> with
          Qmee.
        </Txt>
      </>
    ),
  },
  'market-research': {
    metaData: {
      title: 'Qmee - Earn real cash rewards with paid market research.',
      description: defaultDescription,
    },
    leftColumnContent: (
      <>
        <Heading level={1}>
          Earn real cash rewards with <Txt component="strong">paid market research</Txt>
        </Heading>
        <Txt component="p">
          Forget swag or points - withdraw your <Txt component="strong">cash instantly</Txt> with
          Qmee.
        </Txt>
      </>
    ),
  },
  opinion: {
    metaData: {
      title: 'Qmee - Turn opinions into payment with paid surveys.',
      description: defaultDescription,
    },
    leftColumnContent: (
      <>
        <Heading level={1}>
          Turn opinions into payment with <Txt component="strong">paid surveys</Txt>
        </Heading>
        <Txt component="p">
          Forget swag or points - withdraw your <Txt component="strong">cash instantly</Txt> with
          Qmee.
        </Txt>
      </>
    ),
  },
  'paid-surveys': {
    metaData: {
      title: 'Qmee - Take paid surveys to earn real cash rewards.',
      description: defaultDescription,
    },
    leftColumnContent: (
      <>
        <Heading level={1}>
          Take paid surveys to earn <Txt component="strong">real cash</Txt> rewards
        </Heading>
        <Txt component="p">
          Forget swag or points - withdraw your <Txt component="strong">cash instantly</Txt> with
          Qmee.
        </Txt>
      </>
    ),
  },
  polls: {
    metaData: {
      title: 'Qmee - Turn polls into payment with paid surveys.',
      description: defaultDescription,
    },
    leftColumnContent: (
      <>
        <Heading level={1}>
          Turn polls into payment with <Txt component="strong">paid surveys</Txt>
        </Heading>
        <Txt component="p">
          Forget swag or points - withdraw your <Txt component="strong">cash instantly</Txt> with
          Qmee.
        </Txt>
      </>
    ),
  },
  questionnaire: {
    metaData: {
      title: 'Qmee - Take paid questionnaires to earn real cash rewards.',
      description: defaultDescription,
    },
    leftColumnContent: (
      <>
        <Heading level={1}>
          Take paid questionnaires to earn <Txt component="strong">real cash</Txt> rewards
        </Heading>
        <Txt component="p">
          Forget swag or points - withdraw your <Txt component="strong">cash instantly</Txt> with
          Qmee.
        </Txt>
      </>
    ),
  },
  'save-the-student': {
    metaData: {
      title: 'Qmee - Share your opinion and shop to earn real cash rewards.',
      description: defaultDescription,
    },
    leftColumnContent: (
      <>
        <Heading level={1}>
          Earn money online with <Txt component="strong">Qmee</Txt>
        </Heading>
        <Txt component="p">Earn real cash rewards for browsing the web.</Txt>
        <Txt component="p">
          Forget swag or points - withdraw your <Txt component="strong">cash instantly</Txt> with
          Qmee.
        </Txt>
      </>
    ),
  },
  'side-hustle': {
    metaData: {
      title: 'Qmee - Make paid surveys your new side hustle.',
      description: defaultDescription,
    },
    leftColumnContent: (
      <>
        <Heading level={1}>
          Make paid surveys your new <Txt component="strong">side hustle</Txt>
        </Heading>
        <Txt component="p">
          Forget swag or points - withdraw your <Txt component="strong">cash instantly</Txt> with
          Qmee.
        </Txt>
      </>
    ),
  },
  'homepage-2': {
    metaData: {
      title: 'Qmee - Take surveys with Qmee',
      description: defaultDescription,
    },
    leftColumnContent: (
      <>
        <Heading level={1}>Take surveys with Qmee</Heading>
        <Txt component="p">
          Kill time productively with Qmee surveys and enjoy no minimum withdrawal.
        </Txt>
      </>
    ),
  },
  'homepage-3': {
    metaData: {
      title: 'Qmee - Get rewarded with Qmee surveys',
      description: defaultDescription,
    },
    leftColumnContent: (
      <>
        <Heading level={1}>Get rewarded with Qmee surveys</Heading>
        <Txt component="p">
          Kill time productively by filling out surveys with Qmee. No minimum withdrawal.
        </Txt>
      </>
    ),
  },
};

export default LANDING_PAGES;
